import { state } from '@/shared/components/player/store';
import { replaceEmbeddedRoute } from '@/shared/utils';

export default {
  computed: {
    previousRelatedProduct() {
      return state.previousRelatedProduct || {};
    },
  },
  methods: {
    playPreviousRelatedProduct() {
      if (!state.isEmbedded) {
        return;
      }

      const { slug, id, type, articleId, articleType, articleSlug } = this.previousRelatedProduct;

      state.previousRelatedProducts.pop();
      state.nextRelatedProducts.unshift(state.product);

      replaceEmbeddedRoute({ slug, id, type, articleId, articleType, articleSlug, component: this });
    },
  },
};
